export type TranslatableTileName = {
  name?: string | null;
  nameId?: number | null;
  Name?: Record<string, unknown> | null;
};

export function getSQDCTileName(
  tile: TranslatableTileName | null | undefined,
  translate: (key: string) => unknown,
) {
  if (tile?.nameId != null && tile.nameId > 0) {
    return String(translate(`dynamic.${tile.nameId}`));
  }
  const inlineName = Object.entries(tile?.Name ?? {}).find(
    ([key, value]) => key !== "id" && typeof value === "string" && value.trim() !== "",
  )?.[1];
  if (typeof inlineName === "string") {
    return inlineName;
  }
  return tile?.name ?? "";
}
